/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { forwardRef } from 'react';
// material
import { IconButton, IconButtonProps } from '@mui/material';
//
// import { ButtonAnimate } from '../animate';

// ----------------------------------------------------------------------

const MIconButton = forwardRef(({ children, ...other }, ref) => (
  // <ButtonAnimate>
  <IconButton ref={ref} {...other}>
    {children}
  </IconButton>
  // </ButtonAnimate>
));

export default MIconButton;
